/**
 * UI Component Constants
 * UI component'leri için sabit değerler
 */

export class UIConstants {
  // NumberInput defaults
  static readonly NUMBER_INPUT_DEFAULT_MIN = 0;
  static readonly NUMBER_INPUT_DEFAULT_MAX = 999;
  static readonly NUMBER_INPUT_DEFAULT_STEP = 1;
  
  // Cabin count limits
  static readonly CABIN_MIN_COUNT = 0;
  static readonly CABIN_MAX_COUNT = 20;
  static readonly CABIN_STEP = 1;
  
  // Date picker
  static readonly DATE_PICKER_DISABLE_BEFORE_TODAY = true;
}

